module.exports = __webpack_public_path__ + "img/产业园信息管理平台2.2c32ce67.png";